<template>
    <div class="property">
        <span class="property__name" v-if="showPropertyName">
            {{ techReservation.tech_reservation.property_name }}
        </span>
        <div class="property__name__separator" v-if="showPropertyName" />
        <div class="property__check-in-out">
            <div class="property__check-in-out__check-in">
                <div class="property__check-in-out__check-in__label">
                    Check-in
                </div>
                <div class="property__check-in-out__check-in__date">
                    {{ formattedDates.fromDate }}
                </div>
                <div class="property__check-in-out__check-in__time">
                    from
                    {{ formattedTimes.fromTime }}
                </div>
            </div>
            <div class="property__check-in-out__check-out">
                <div class="property__check-in-out__check-out__label">
                    Check-out
                </div>
                <div class="property__check-in-out__check-out__date">
                    {{ formattedDates.toDate }}
                </div>
                <div class="property__check-in-out__check-out__time">
                    by
                    {{ formattedTimes.toTime }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

export default {
    props: {
        techReservation: {
            type: Object,
            required: true,
        },
        showPropertyName: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        formattedDates() {
            return {
                fromDate: format(
                    parseISO(this.techReservation.tech_reservation.from_date),
                    'EEE, dd MMM yyyy'
                ),
                toDate: format(
                    parseISO(this.techReservation.tech_reservation.to_date),
                    'EEE, dd MMM yyyy'
                ),
            };
        },
        formattedTimes() {
            return {
                fromTime: format(
                    parseISO(
                        this.techReservation.tech_reservation.from_date +
                            ' ' +
                            this.techReservation.tech_reservation.check_in
                    ),
                    'hh:mm a'
                ),
                toTime: format(
                    parseISO(
                        this.techReservation.tech_reservation.to_date +
                            ' ' +
                            this.techReservation.tech_reservation.check_out
                    ),
                    'hh:mm a'
                ),
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.property {
    &__name {
        font-size: 17px;

        &__separator {
            margin-top: 0.5rem;
            margin-bottom: 1rem;
            width: 100px;
            height: 2px;
            background: linear-gradient(
                90deg,
                black,
                black,
                transparent,
                transparent
            );
        }
    }

    &__check-in-out {
        display: flex;

        &__check-in {
            border-right: 1px solid rgba(0, 0, 0, 0.1);
            padding-right: 2rem;
            width: 50%;
        }

        &__check-out {
            padding-left: 2rem;
        }

        &__check-in__label,
        &__check-out__label {
            font-size: 13px;
            margin-bottom: 0.3rem;
        }

        &__check-in__date,
        &__check-out__date {
            font-size: 17px;
            font-weight: bold;
        }

        &__check-in__time,
        &__check-out__time {
            font-size: 13px;
        }
    }

    @media print {
        .property{
            color: #000 !important;
        }
    }
}
</style>
